import {plusIndex, showIndex} from '../textScrumble/_textScrumble';

function about(triggerBtn, mainScreen, sectionAbout, sectionWorks, sectionSertify, sectionContact) {
	const btn = document.querySelectorAll(triggerBtn);
	const main = document.querySelector(mainScreen);
	const about = document.querySelector(sectionAbout);
	const works = document.querySelector(sectionWorks);
	const setr = document.querySelector(sectionSertify);
	const contact = document.querySelector(sectionContact);
	toggleDisplay(about, 'none')
	toggleDisplay(works, 'none')
	toggleDisplay(setr, 'none')
	toggleDisplay(contact, 'none')

	function toggleDisplay(selector, display) {
		selector.style.display = display;
	}

	function showElemet(attr) {
		toggleDisplay(main, 'none')
		if (attr == 'about') {
			toggleDisplay(about, '');
			toggleDisplay(works, 'none');
			toggleDisplay(setr, 'none');
			toggleDisplay(contact, 'none');
		} else if (attr == 'works') {
			toggleDisplay(works, '');
			toggleDisplay(about, 'none');
			toggleDisplay(setr, 'none');
			toggleDisplay(contact, 'none');
		} else if (attr == 'setrify') {
			toggleDisplay(setr, '')
			toggleDisplay(works, 'none');
			toggleDisplay(about, 'none');
			toggleDisplay(contact, 'none');
		} else if (attr == 'contacts') {
			toggleDisplay(contact, '');
			toggleDisplay(setr, 'none')
			toggleDisplay(works, 'none');
			toggleDisplay(about, 'none');
		} else if (attr == 'main') {
			toggleDisplay(main, '')
			toggleDisplay(works, 'none');
			toggleDisplay(about, 'none');
			toggleDisplay(setr, 'none');
			toggleDisplay(contact, 'none');
		} 
	}

	btn.forEach(i => {
		i.addEventListener('click', (e) => {
			if (e.target.getAttribute('id') != 'main') {
				plusIndex(1);
				showElemet(e.target.getAttribute('id'))
			} else {
				plusIndex(0);
				showElemet(e.target.getAttribute('id'))
			}
			
		})
	})
}

export default about;